import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  Drawer,
  Grid,
  Grow,
  Toolbar,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";

import "../styles/index.scss";
import { en, links } from "../content";

function Navbar(props) {
  const theme = useTheme();
  const content = en.header;
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const location = useLocation();
  const pathName = location.pathname.split("/")[1];

  const renderDesktopContents = () => (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box className="title" component={Link} to="/">
        {content.logo}
      </Box>
      <Box display="flex" alignItems="center">
        <Box mx={2} className="body underline" component={Link} to="/">
          {content.about}
        </Box>
        <Box mx={2} className="body underline" component={Link} to="/projects">
          {content.project}
        </Box>
        <Box mx={2} className="body underline">
          <a href={links.resume} target="_blank" rel="noreferrer">
            {content.resume}
          </a>
        </Box>
      </Box>
    </Box>
  );

  const renderMobileContents = () => (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>{content.logo}</Box>
        <Box>
          <MenuIcon onClick={() => setDrawerOpen((open) => !open)} />
        </Box>
      </Box>
      <Drawer anchor="top" open={drawerOpen} transitionDuration={500}>
        <Box
          className="drawer"
          height="100vh"
          display="flex"
          flexDirection="column"
          py={4}
        >
          <Grow in timeout={2000}>
            <Box
              flex={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              component={Link}
              to="/"
              className="drawerButton"
            >
              {content.about}
            </Box>
          </Grow>
          <Grow in timeout={3000}>
            <Box
              flex={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              component={Link}
              to="/projects"
              className="drawerButton"
            >
              {content.project}
            </Box>
          </Grow>
          <Grow in timeout={4000}>
            <Box
              flex={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              className="drawerButton"
            >
              <a href={links.resume} target="_blank" rel="noreferrer">
                {content.resume}
              </a>
            </Box>
          </Grow>
        </Box>
      </Drawer>
    </>
  );

  return (
    <React.Fragment>
      <AppBar
        className="navBar"
        style={{
          zIndex: 2000,
          background: "none",
          backgroundColor: isDesktop
            ? !pathName
              ? "transparent"
              : "#292d41"
            : "#292d41",
        }}
      >
        <Toolbar>
          <Grid container justifyContent="center">
            <Grid item lg={8} md={9} xs={10}>
              {isDesktop ? renderDesktopContents() : renderMobileContents()}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}

export default Navbar;
